<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load" class="align-items-center">
                    <b-col lg="6" sm="12" class="text-left">
                        <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                    </b-col>

                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" @change="load()" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" />
                    </b-col>

                    <b-col lg="3" sm="1" class="ml-5 d-flex justify-content-end align-items-center">
                        <b-button id="limpar" class="my-2" size="sm" style="height: 40px" pill variant="primary"
                            @click="limpar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizar" class="ml-3 my-2" size="sm" style="height: 40px" pill variant="primary"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button id="novo" class="ml-1 mr-5 my-2" style="height: 40px"
                            @click="showAlmoxarifadoModal(null)" size="sm" pill variant="secondary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" show-empty @row-dblclicked="almoxarifadoSelect">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                    </template>


                    <template v-slot:cell(temAlmoxarifes)="row">
                        <b-button style="color:red; border-color:red" v-if="row.item.semAlmoxarife"
                            :id="row.index + 'warning-button'" class="my-2" size="sm" pill variant="primary">
                            <b-icon icon="exclamation-triangle-fill" />
                            <b-tooltip :target="row.index + 'warning-button'"
                                title="Almoxarifado sem almoxarifes..."></b-tooltip>
                        </b-button>

                    </template>


                    <template v-slot:cell(inventariando)="row">
                        <b-button v-if="row.item.inventariando == 1" :id="row.index + 'warning-button'" class="my-2"
                            size="sm" pill variant="primary">
                            <b-icon icon="exclamation-triangle-fill" />
                            <b-tooltip :target="row.index + 'warning-button'"
                                title="Almoxarifado sendo inventariado..."></b-tooltip>
                        </b-button>

                    </template>

                    <template v-slot:cell(editar)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" v-if="row.item.inventariando != 1"
                            :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(bloquear)="row">
                        <b-button v-if="row.item.inventariando != 1" :disabled="!temPrivilegioBloquear()"
                            :id="row.index + 'bloquear-button'" class="my-2" size="sm" pill variant="primary"
                            @click="bloquear(row.item)">
                            <b-icon :icon="row.item.bloqueado == 0 ? 'lock-fill' : 'unlock-fill'" />
                            <b-tooltip :target="row.index + 'bloquear-button'" :title="row.item.bloqueado == 0 ? 'Bloquear...' : 'Desbloquear...'
                                "></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(configuracoes)="row">
                        <b-button v-if="row.item.inventariando != 1 && (isAdmin() || row.item.usuarioIsAlmoxarife)"
                            :disabled="!temPrivilegioConfigurar()" :id="row.index + 'configurar'" class="my-2" size="sm"
                            pill variant="primary" @click="config(row.item)">
                            <b-icon icon="gear" />
                            <b-tooltip :target="row.index + 'configurar'" title="Configurar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(situacao)="row">
                        <div v-if="row.item.inventariando != 1" :id="row.index + 'ativar'">
                            <b-form-checkbox v-model="row.item.situacao" switch :value="1" :unchecked-value="0"
                                @change="ativaInativa(row.item)" />
                            <b-tooltip :target="row.index + 'ativar'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>

                    <template v-slot:cell(excluir)="row">
                        <b-button v-if="row.item.inventariando != 1" :disabled="!temPrivilegioExcluir()"
                            :id="row.index + 'excluir'" class="my-2" size="sm" pill variant="primary"
                            @click="remove(row.item)">
                            <b-icon icon="trash-fill" />
                            <b-tooltip :target="row.index + 'excluir'" title="Remover..."></b-tooltip>
                        </b-button>
                    </template>

                    <template #cell(show_details)="row">
                        <span :class="row.item._showDetails ? 'ti-angle-up' : 'ti-angle-right'"
                            @click="detalhes(row.toggleDetails, row.item)"></span>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <BloqueioModal v-if="showModalBloqueio" @close="cancelarBloqueio" :prefix="title"
                @confirmar="confirmarBloqueio" />
        </b-card-body>
        <AlmoxarifadoForm v-if="showModalAlmoxarifado" @close="cancelar" :prefix="title" :id="currentAlmoxarifadoId" />
        <ModalConfiguracaoAlmoxarifado v-if="showModalConfiguracaoAlmoxarifado" @close="cancelar" :prefix="title"
            :almoxarifado="almoxarifado" />

    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import AlmoxarifadoForm from "./AlmoxarifadoForm.vue"
import BloqueioModal from "@/modules/almoxarifados/almoxarifado/BloqueioModal.vue"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import ModalConfiguracaoAlmoxarifado from "./ModalConfiguracaoAlmoxarifado.vue"
import { isUserAdmin } from '@/core/auth';

export default {
    components: {
        BloqueioModal,
        LgFormInput,
        LgFormConstSelect,
        AlmoxarifadoForm,
        ModalConfiguracaoAlmoxarifado
    },

    mixins: [ConfirmMixin, ListResourceMixin],

    props: {
        departamento: Object,
        produto: Object,
        onDblClickAlmoxarifado: Function,
        title: {
            type: String,
            default: "Almoxarifado >",
        },
    },

    data() {
        return {
            almoxarifado: {},
            showModalConfiguracaoAlmoxarifado: false,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            showModalAlmoxarifado: false,
            showModalBloqueio: false,
            showModal: false,
            showEditModal: false,
            descricao: "",
            filter: "",
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { value: null, text: "Todos" },
                    { value: 1, text: "Ativo" },
                    { value: 0, text: "Inativo" },
                ],
            },
            currentAlmoxarifadoId: null,
            currentItem: null,
        }
    },

    watch: {
        page() {
            this.load()
        },
    },

    beforeMount() {
        this.$service = new ResourceService(`/api/almoxarifados`)
        this.$serviceEventoLeitura = new ResourceService(`/api/almoxarifados`)

        this.load()
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "descricao",
                    label: "Nome",
                },
                {
                    key: "temAlmoxarifes",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",

                    label: " "
                },

                {
                    key: "inventariando",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",

                    label: " "
                },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "configuracoes",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "bloquear",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "excluir",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ]
        },
    },
    methods: {
        isAdmin() {
            return isUserAdmin();
        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.ALMOXARIFADO_EDITAR);

        },
        temPrivilegioConfigurar() {
            return verificaPrivilegio(PrivilegiosEnum.ALMOXARIFADO_CONFIGURAR);

        },
        temPrivilegioBloquear() {
            return verificaPrivilegio(PrivilegiosEnum.ALMOXARIFADO_BLOQUEAR);

        },
        temPrivilegioExcluir() {
            return verificaPrivilegio(PrivilegiosEnum.ALMOXARIFADO_EXCLUIR);

        },
        temPrivilegioGerenciar() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_ALMOXARIFADO);

        },

        async load() {
            this.filtro = {}

            if (this.departamento && this.departamento.id) {
                this.filtro.departamento = this.departamento.id;
            }

            if (this.produto && this.produto.id)
                this.filtro.produto = this.produto.id;

            if (this.form.descricao) {
                this.filtro.descricao = this.form.descricao
            }
            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao
            }


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },

        showAlmoxarifadoModal(id) {
            this.currentAlmoxarifadoId = id
            this.showModalAlmoxarifado = true
        },

        async detalhes(fuctionToggleDetails) {
            await fuctionToggleDetails()
        },
        async remove(item) {
            await this.$removeResource(item)
        },
        verificaPermissao() {

            return JSON.parse(localStorage.getItem("context")).usuario.master;

        },
        async ativaInativa(item) {

            if (!this.verificaPermissao()) {
                item.situacao = item.situacao === 1 ? 0 : 1

                this.$notify({
                    type: "danger",
                    message: "Para ATIVAR/INATIVAR um almoxarifado, contate o Administrador.",
                });
                return;
            }

            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "inativar") + " o almoxarifado?",
                item.descricao.toUpperCase()
            );

            if (response == true) {
                this.confirmarAtivaInativa(item)
            }
            else
                item.situacao = item.situacao === 1 ? 0 : 1
        },

        async confirmarAtivaInativa(item) {
            this.busy = true;
            const { status } = await this.$service.alteraSituacao(item)
            this.busy = false;

            if (status === 200) {
                this.$notify({
                    type: "success",
                    message: "Registro atualizado com sucesso.",
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: "Erro ao atualizar o registro.",
                })
            }
        },
        async almoxarifadoSelect(item) {
            this.$emit("onDblClickAlmoxarifado", item)
        },
        async config(item) {
            this.almoxarifado = item;
            this.showModalConfiguracaoAlmoxarifado = true;
        },
        async editar(almoxarifado) {
            this.showAlmoxarifadoModal(almoxarifado.id)
        },
        cancelar() {
            this.currentAlmoxarifadoId = null
            this.almoxarifado = {};
            this.showModalConfiguracaoAlmoxarifado = false;
            this.showModalAlmoxarifado = false
            this.load()
        },
        limpar() {
            this.form.situacao = null
            this.form.descricao = ""
            this.load()
        },
        async bloquear(item) {
            let response = await this.$confirm(
                "Deseja " +
                (item.bloqueado === 0 ? "bloquear" : "desbloquear") +
                " o Almoxarifado " +
                item.descricao.toUpperCase() +
                "?"
            )
            if (response == true) {
                this.currentItem = item
                this.showModalBloqueio = true
            }
        },
        cancelarBloqueio() {
            this.currentItem = null
            this.showModalBloqueio = false
        },
        async confirmarBloqueio(form) {
            const item = this.currentItem
            item.bloqueado = item.bloqueado == 1 ? 0 : 1
            item.justificativaBloqueio = form.justificativa
            item.mensagemBloqueio = form.mensagem

            this.showModalBloqueio = false

            await this.confirmarBloqueado(item)
        },
        async confirmarBloqueado(item) {
            const { status } = await this.$service.alteraBloqueado(item)

            if (status === 200) {
                this.$notify({
                    type: "success",
                    message: "Registro atualizado com sucesso.",
                })
                this.load()
            } else {
                this.$notify({
                    type: "danger",
                    message: "Erro ao atualizar o registro.",
                })
            }
        },
    },
}
</script>
